// extracted by mini-css-extract-plugin
export default {"balances":"LedgerBalances_balances__PVQUf","label":"LedgerBalances_label__aQ4Pt","value":"LedgerBalances_value__YXEWt","message":"LedgerBalances_message__caZxg"};